import { IRenderer } from './renderer';

export class Position {
  public readonly X: number;
  public readonly Y: number;

  constructor(x: number, y: number) {
    this.X = x;
    this.Y = y;
  }
}

export class PreviewModel {
  public Data: any;
  public R: IRenderer;
  public position: Position;

  get header(): string {
    return this.R.RenderHeader(this.Data);
  }
  get body(): string {
    return this.R.RenderBody(this.Data);
  }

  clear(): void {
    this.Data = undefined;
    this.R = undefined;
    this.position = undefined;
  }
}




// WEBPACK FOOTER //
// ./src/app/common/preview.service/preview.model.ts